export const getStyles = ({ companyIndex }) => ({
	featuredCompanyHeader: {
		wrapper:
			"tw:py-2 tw:px-2 tw:flex tw:justify-center tw:bg-[#359492] tw:text-white tw:rounded-t-lg",
		contentWrapper:
			"tw:text-center tw:text-base tw:font-bold tw:leading-6 tw:tracking-[-0.16px]",
	},
	serviceFlag: {
		wrapper: "",
		flag: `tw:absolute tw:top-4 tw:left-4 tw:w-6 tw:h-6 tw:flex tw:items-center tw:justify-center tw:rounded-full tw:lg:w-8 tw:lg:h-8 tw:lg:top-2/4 tw:lg:-translate-y-2/4 tw:xl:left-6 ${
			companyIndex === 0
				? "tw:bg-[#616096] tw:text-white"
				: "tw:bg-[#EDEDEE] tw:text-[#22293A]"
		}`,
		number: `tw:text-current tw:text-sm tw:font-medium tw:leading-normal tw:lg:text-base tw:lg:leading-6 tw:lg:top-6`,
		contentWrapper:
			"tw:absolute tw:top-4 tw:left-12 tw:py-1 tw:pl-2 tw:pr-4 tw:flex tw:items-center tw:gap-1 tw:bg-[#2A7675] tw:text-white tw:lg:gap-2 tw:[clip-path:polygon(100%_0,calc(100%-10px)_50%,100%_100%,0_100%,0_0)] tw:lg:left-0",
		icon: "tw:inline-flex",
		text: "tw:text-xs tw:font-semibold tw:leading-4",
	},
	companyLogo: { picture: "tw:flex", image: "tw:w-[160px]" },
	rating: {
		wrapper:
			"tw:w-fit tw:inline-flex tw:items-center tw:gap-1.5 tw:rounded-full tw:bg-white tw:py-2.5 tw:px-4 tw:shadow-[0px_4px_24px_0px_rgba(23,23,23,0.08),0px_0px_1px_0px_rgba(23,23,23,0.16)] tw:lg:py-2 tw:lg:pr-4 tw:lg:pl-3.5",
		score:
			"tw:text-2xl tw:font-bold tw:leading-6 tw:tracking-[-0.96px] tw:text-[#22293A] tw:lg:text-[28px] tw:lg:leading-9 tw:lg:tracking-[-1.12px]",
		stars: "tw:flex tw:flex-col tw:gap-1",
		starColor: "tw:text-[#359492]",
		starSize: "tw:text-sm tw:lg:text-base",
		count: "tw:ml-1 tw:text-xs tw:font-semibold tw:leading-3 tw:text-[#22293A]",
	},
	productDescription:
		"tw:text-pretty tw:text-lg tw:font-bold tw:leading-6 tw:tracking-[-0.18px] tw:text-[#131D2B] tw:lg:text-xl tw:lg:leading-[1.75rem] tw:lg:tracking-[-0.2px]",
	coupon: {
		wrapper: `tw:h-full tw:p-2 tw:rounded-lg tw:bg-white tw:border-dashed tw:border tw:shadow-[0px_0px_1px_rgba(23,23,23,0.16),0px_4px_24px_rgba(23,23,23,0.08)] ${companyIndex === 0 ? " tw:border-[#E1255B]" : "tw:border-[#616096]"}`,
		offerWrapper: `tw:flex tw:justify-center tw:items-center tw:lg:h-[30px] tw:h-[32px] tw:rounded-t-lg ${companyIndex === 0 ? " tw:bg-[#E1255B]" : "tw:bg-[#616096]"}`,
		offerIcon: `tw:inline-flex tw:items-center tw:mr-1.5 tw:shrink-0 tw:text-white ${companyIndex === 0 ? " tw:text-[22px]" : "tw:text-[22px] tw:lg:text-[18px]"}`,
		offerContent: `tw:text-white tw:font-bold tw:uppercase ${companyIndex === 0 ? "tw:lg:text-[12px] tw:lg:leading-[22px] tw:lg:tracking-[0.24px] tw:text-[14px] tw:leading-[22px] tw:tracking-[0.28px]" : "tw:lg:text-[10px] tw:lg:leading-[18px] tw:lg:tracking-[0.2px] tw:text-[12px] tw:leading-[22px] tw:tracking-[0.24px]"}`,
		contentWrapper: `tw:px-2 tw:rounded-b-lg tw:bg-linear-to-b/srgb tw:flex tw:flex-col tw:items-center tw:justify-center tw:grow ${companyIndex === 0 ? " tw:from-[rgba(253,238,242,0)] tw:via-[rgba(253,238,242,0.3542)] tw:to-[#FDEEF2]" : "tw:from-[rgba(245,243,255,0)] tw:via-[rgba(245,243,255,0.3167)] tw:to-[#F5F3FF]"}`,
		desktopLargeContent:
			"tw:hidden tw:lg:flex tw:text-[24px] tw:font-bold tw:text-[#E1255B]",
		desktopContent: `tw:hidden tw:lg:flex tw:max-w-[70%] tw:text-center ${companyIndex === 0 ? " tw:text-[#E1255B] tw:lg:text-[14px] tw:lg:leading-[20px] tw:text-[20px] tw:font-bold tw:leading-[26px] tw:tracking-[-0.2px]" : "tw:text-[#616096] tw:lg:text-[14px] tw:lg:leading-[20px] tw:text-[16px] tw:font-semibold tw:leading-6 tw:tracking-[-0.16px]"}`,
		mobileContent: `tw:flex tw:lg:hidden tw:max-w-[80%] tw:text-center ${companyIndex === 0 ? " tw:text-[#E1255B] tw:lg:text-[14px] tw:lg:leading-[20px] tw:text-[20px] tw:font-bold tw:leading-[26px] tw:tracking-[-0.2px]" : "tw:text-[#616096] tw:lg:text-[14px] tw:lg:leading-[20px] tw:text-[16px] tw:font-semibold tw:leading-6 tw:tracking-[-0.16px]"}`,
	},
	benefitsList: {
		wrapper: "tw:mt-4",
		list: "tw:flex tw:flex-col tw:gap-2 tw:justify-center",
		listItem:
			"tw:flex tw:text-[#22293A] tw:text-sm tw:gap-2 tw:leading-6 tw:text-pretty",
	},
	socialProof: {
		wrapper:
			"tw:relative tw:flex tw:mb-3.5 tw:rounded-lg tw:max-w-fit tw:bg-white tw:p-2 tw:filter-[drop-shadow(0px_0px_1px_rgba(88,102,126,0.48))_drop-shadow(0px_0px_24px_rgba(88,102,126,0.10))] tw:after:absolute tw:after:right-[calc(50%-6px)] tw:after:w-2.5 tw:after:h-2.5 tw:after:translate-x-0 tw:after:-translate-y-2/4 tw:after:rotate-45 tw:after:bg-white tw:after:overflow-hidden tw:after:pointer-events-none tw:after:top-full tw:lg:mt-3.5 tw:lg:after:top-0",
		contentWrapper:
			"tw:flex tw:flex-row tw:justify-center tw:items-center tw:gap-2",
		contentIcon: "tw:text-[#F68700] tw:text-[32px]",
		content:
			"tw:min-w-[102px] tw:max-w-[106px] tw:leading-4 tw:font-semibold tw:text-[11px] tw:text-left tw:text-[#22293A]",
	},
	visitLink: {
		wrapper:
			"tw:inline-flex tw:w-full tw:group tw:justify-center tw:items-center tw:p-2 tw:bg-[#359492] tw:rounded-lg tw:transition tw:duration-300 tw:gap-2 tw:cursor-pointer tw:hover:bg-[#246161] tw:lg:py-3",
		contentWrapper:
			"tw:text-white tw:font-semibold tw:leading-6 tw:text-sm tw:lg:text-base tw:text-center",
		iconClass:
			"tw:inline-flex tw:text-2xl tw:text-white tw:transition-all tw:duration-300 tw:group-hover:translate-x-1 tw:lg:hidden tw:xl:inline-flex",
	},
});
